<template>
  <CCard>
    <CCardHeader>
      <slot name="header">
        <span><CIcon name="cil-grid" class="mr-2"/> {{caption}} </span>
        <CButton color="primary" class="px-4" @click="add()">Assign Module</CButton>
      </slot>
    </CCardHeader>
    <CCardBody>
      <CDataTable
        :hover="hover"
        :striped="striped"
        :bordered="bordered"
        :small="small"
        :fixed="fixed"
        :items="items"
        :fields="fields"
        :items-per-page="small ? 10 : 5"
        :dark="dark"
        pagination
		tableFilter
		sorter		
		itemsPerPageSelect 		
      >
      <template #status="{item}">         
		  <td>
			    <CBadge :color="getBadge(item.status)" v-on:click="change_status(item.Role_Id);"	:id="'status_'+item.Role_Id">{{item.status}}</CBadge>
      </td>
    </template>
    <template #action="{item}">         
		  <td>
            <CButton color="primary" class="mr-2" :color="getEdit(item.action)" @click="edit(item.Item_Id,item.Role_Id)">Edit</CButton>
			<!-- <CButton :color="getDelete(item.action)" @click="deletepop(item.Role_Id)">Delete</CButton>			 -->
          </td>
      </template>
	  
      </CDataTable>
	 
	 
    </CCardBody>
  </CCard>
</template>


<script>
import axios from "axios";
export default {
  name: 'Manage_assign_modules',
  data () {
    return {
      myModal: false
	}
  },
  props: {
    items: Array,
    fields: {
      type: Array,
      default () {
        //return ['Item_Id','Role_Id','RoleName', 'Module_Ids','action']
		return ['Role_Id','RoleName', 'Module_Ids','action']
      }
    },
    caption: {
      type: String,
      default: 'Assigned Modules'
    },
    hover: Boolean,
    striped: Boolean,
    bordered: Boolean,
    small: Boolean,
    fixed: Boolean,
    dark: Boolean,
    responsive: Boolean
  },
  methods: {
	getEdit (color) {
      return 'primary';
    },
	getDelete(color){
		return 'danger';
	},
	edit(Item_Id,id){						
		localStorage.setItem("edit_id",id);
		localStorage.setItem("Item_Id",Item_Id);		
		this.$router.push({path:'edit_assign_module'})
	},
	add(){
		// console.log('add');
		this.$router.push({path:'Assign_module'})
	},
  },
}
</script>